<!--<div class="ideaword-container" style="height:auto;">
  <div class="ideaword-frame">
    <div class="ideaword-header" style="padding:0;">{{ideaword.word}}</div>
    <div class="ideaword-body" style="overflow: auto; height: 100%; max-height: 200px;" [innerHTML]="ideaword.definition"></div>
  </div>
</div>

<div style="margin:0px">
  <b>Want to learn more?</b>
  <a class="a-link" style="margin-left:15px;" href="mailto:idea@isg-one.com?subject=%20IDEA%20Request">Contact the ISG IDEA Team.</a>
</div>-->



<div class="ideaword-container">
  <div class="ideaword-frame">
    <!--<div class="ideaword-header">{{wordOfTheWeek.word}}</div>-->
    <div class="ideaword-header" style="padding:0;">{{wordOfTheWeek.word}}</div>
    <!--<span style=" z-index: 9;position: relative;" title="{{HTMLdecode(wordOfTheWeek.details)}}">{{showLessThan300Character(HTMLdecode(wordOfTheWeek.details))}}</span>-->
    <div class="ideaword-body" style="overflow: auto; height: 100%; max-height: 200px;" [innerHTML]="wordOfTheWeek.details"></div>


    <!--<div class="ideaword-footer"><span class="question">Want to learn more?</span><br /><span class="link">Contact the <a href="mailto:idea@isg-one.com?subject=%20IDEA%20Request">ISG IDEA Team</a>.</span></div>-->
    <div style="margin:0px">
      <b>Want to learn more?</b>
      <a class="a-link" style="margin-left:15px;" href="mailto:idea@isg-one.com?subject=%20IDEA%20Request">Contact the ISG IDEA Team.</a>
    </div>
  </div>
</div>
